export const RESET_INVENTORY_TAGS_VIEW = 'resetInventoryTagsView';
export const SHOW_ADD_INVENTORY_TAGS_MODAL = 'showAddInventoryTagsModal';
export const HIDE_ADD_INVENTORY_TAGS_MODAL = 'hideAddInventoryTagsModal';

export const showAddInventoryTagsModal = () => ({
  type: SHOW_ADD_INVENTORY_TAGS_MODAL
});

export const hideAddInventoryTagsModal = () => ({
  type: HIDE_ADD_INVENTORY_TAGS_MODAL
});
